module.exports = __webpack_public_path__ + "static/media/Biotech Pharmaceuticals logo.f2a450ce.png";